export default __webpack_public_path__ + "static/media/system_drop_down_list.2bed7aef.svg";